import { render, staticRenderFns } from "./AsignarAulas.vue?vue&type=template&id=42f8b152"
import script from "./AsignarAulas.vue?vue&type=script&lang=js"
export * from "./AsignarAulas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports